import { useCallback } from "react";
import { useNavigate, useLocation } from "react-router";
import useQueryParams from "./useQueryParams";

const PARAM_MODAL = "itemLabels";
const PARAM_SHIPMENT_ID = "labelShipmentId";
const PARAM_SHIPMENT_ITEM_ID = "labelShipmentItemId";
const PARAM_ASSET_ID = "labelAssetId";

const ALL_PARAMS = [PARAM_MODAL, PARAM_SHIPMENT_ID, PARAM_SHIPMENT_ITEM_ID, PARAM_ASSET_ID];

export default function useItemLabelsModal() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = useQueryParams();

  const isOpen = queryParams.has(PARAM_MODAL);
  const shipmentId = queryParams.get(PARAM_SHIPMENT_ID);
  const shipmentItemId = queryParams.get(PARAM_SHIPMENT_ITEM_ID);
  const assetId = queryParams.get(PARAM_ASSET_ID);

  const openForShipment = useCallback(
    (shipmentId, shipmentItemId) => {
      const params = new URLSearchParams(location.search);
      params.set(PARAM_MODAL, "true");
      params.set(PARAM_SHIPMENT_ID, shipmentId);
      if (shipmentItemId) params.set(PARAM_SHIPMENT_ITEM_ID, shipmentItemId);
      else params.delete(PARAM_SHIPMENT_ITEM_ID);
      params.delete(PARAM_ASSET_ID);
      navigate({ search: params.toString() });
    },
    [navigate, location.search]
  );

  const openForAsset = useCallback(
    assetId => {
      const params = new URLSearchParams(location.search);
      params.set(PARAM_MODAL, "true");
      params.set(PARAM_ASSET_ID, assetId);
      params.delete(PARAM_SHIPMENT_ID);
      params.delete(PARAM_SHIPMENT_ITEM_ID);
      navigate({ search: params.toString() });
    },
    [navigate, location.search]
  );

  const close = useCallback(() => {
    const params = new URLSearchParams(location.search);
    ALL_PARAMS.forEach(p => params.delete(p));
    navigate({ search: params.toString() }, { replace: true });
  }, [navigate, location.search]);

  return { isOpen, shipmentId, shipmentItemId, assetId, openForShipment, openForAsset, close };
}
